const tableTitleGroup = {
  title: 'Grupos',
  placeholder: 'Pesquisar por grupo',
  Typography: 'Nenhum resultado encontrado'
};

export default tableTitleGroup;
